/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationsControllerFindOneQueryResponse, NotificationsControllerFindOnePathParams, NotificationsControllerFindOneQueryParams, NotificationsControllerFindOne400, NotificationsControllerFindOne401, NotificationsControllerFindOne403, NotificationsControllerFindOne404 } from "../../models/notificationsController/NotificationsControllerFindOne";

function getNotificationsControllerFindOneUrl(id: NotificationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/notifications/${id}` as const }  
  return res
}

/**
 * @description Retrieve a single notification. User can only access their own notifications.
 * @summary Get a notification by ID
 * {@link /api/v1/notifications/:id}
 */
export async function notificationsControllerFindOne(id: NotificationsControllerFindOnePathParams["id"], params?: NotificationsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationsControllerFindOneQueryResponse, ResponseErrorConfig<NotificationsControllerFindOne400 | NotificationsControllerFindOne401 | NotificationsControllerFindOne403 | NotificationsControllerFindOne404>, unknown>({ method : "GET", url : getNotificationsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}